<footer id="footer" class="rodext" role="contentinfo">
  <div class="container">
    <address>
    © SUBTI - Subsecretaria de Tecnologia da Informação<br />
    Rua Francisco Rubim, 169, Bento Ferreira, Vitória, ES. CEP 29050-680
    </address>
  </div>
</footer>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbk.html